export default __webpack_public_path__ + "static/media/videos.9c0b6986.svg";